module.exports = __webpack_public_path__ + "img/cash-on-delivery-sm.24c1abb9.png";